import { InjectionToken, Provider } from '@angular/core';

export interface AssistanceRequestsApiConfig {
  baseUrl: string;
}

export const ASSISTANCE_REQUESTS_API_CONFIG = new InjectionToken<AssistanceRequestsApiConfig>(
  'ASSISTANCE_REQUESTS_API_CONFIG'
);

export function provideAssistanceRequestsApiConfig(baseUrl: string): Provider {
  return {
    provide: ASSISTANCE_REQUESTS_API_CONFIG,
    useValue: { baseUrl },
  };
}
